module.exports = __webpack_public_path__ + "media/11_Long.a4433e11.mp3";